import { AddShoppingCart } from '@mui/icons-material';
import { Alert, type AlertProps, Button } from '@mui/material';
import type { ReactNode } from 'react';
import { getAddProductToCartUrl } from '@/utils/client/route';

export default function BuyCoursePrompt({
  children,
  wpProductId,
  variant = 'standard',
}: {
  children: string | ReactNode;
  wpProductId: number;
  variant?: AlertProps['variant'];
}) {
  return (
    <Alert
      severity="info"
      variant={variant}
      sx={{ mb: 2 }}
      icon={<AddShoppingCart />}
      action={
        <Button
          variant="contained"
          size="small"
          target="_blank"
          href={getAddProductToCartUrl(wpProductId)}>
          Warenkorb
        </Button>
      }>
      {children}
    </Alert>
  );
}
